module.exports = __webpack_public_path__ + "static/orc_claw_of_luthic-58ac576028c0c8d1eed048a66ab424cc.jpeg";